import { FC, ReactNode } from "react"

import Text from "components/Text/Text"

interface IHeaderTitleProps {
    title: ReactNode
}

const HeaderTitle: FC<IHeaderTitleProps> = ({
    title,
}) => {
    return (
        <Text type="h2" data-testid="header-title">
            {title}
        </Text>
    )
}

export default HeaderTitle
